/**
 * Import Dependency
 */
import React, { Component } from 'react'
import { NavBar } from 'antd-mobile'
import injectSheet from 'react-jss'
import cx from 'classnames'
import lang from 'lodash/lang'
import styles from '../assets/styles/components/NavBarLite'
import previousArrowImage from '../assets/images/previous-arrow.png'

class NavBarLiteComponent extends Component {
  // constructor (props) {
  //   super(props)
  // }

    routeToPreviousHistory = () => {
      const {
        history,
        isCheckoutComplete,
      } = this.props

      if (isCheckoutComplete) return
      if (!lang.isEmpty(history.location.state)) {
        history.goBack()
      } else {
        history.replace({
          pathname: '/home',
          state: { from: history.location.pathname },
        })
      }
    }

    // switchEditMode = () => {
    //     const {
    //         classes,
    //         switchEditMode,
    //         isSwitchOnEditMode
    //     } = this.props;

    //     switchEditMode(!isSwitchOnEditMode);
    // }

    render () {
      const {
        intl,
        classes,
        history,
        orders,
        isFilteredByMe,
        setFilteredByMe,
        switchClearAllOrdersMode,
        // switchEditMode,
        // isSwitchOnEditMode,
        isHistory,
        isCheckoutComplete,
      } = this.props

      const path = history.location.pathname
      const isChangeTable = path === '/basket/change_table'
      const isChangeTableDetail = path === '/basket/change_table/table'

      const navBarLiteStyle = cx(classes['overwrite-navbar-lite'])

      const renderRightContent = () => {
        const _clearAllText = intl.formatMessage({ id: 'checkout.clear_order_all' })
        const _meOnlyText = intl.formatMessage({ id: 'navBarLite.me.only' })
        const _allText = intl.formatMessage({ id: 'navBarLite.all' })
        const _changeTableText = intl.formatMessage({ id: 'footer.change_table' })
        // const _editText = intl.formatMessage({ id: 'navBarLite.edit' })

        const editTextStyle = cx(classes['edit-text'])
        const activeOrderFilterStyle = cx(classes['active-order-filter'])
        const orderFilterStyle = cx(classes['order-filter'])
        const meOnlyOrderFilterStyle = isFilteredByMe ? activeOrderFilterStyle : orderFilterStyle
        const allOrderFilterStyle = !isFilteredByMe ? activeOrderFilterStyle : orderFilterStyle
        // const rightSideBarStyle = cx(classes['right-sidebar']);
        // const pageTitleStyle = cx(classes['page-title']);

        if (isCheckoutComplete) return
        if (isChangeTable) return
        if (isChangeTableDetail) return
        if (isHistory) {
          return (
            <div>
              <span
                onClick={() => { setFilteredByMe(true) }}
                className={meOnlyOrderFilterStyle}
              >{_meOnlyText}
              </span>

              <span
                onClick={() => { setFilteredByMe(false) }}
                className={allOrderFilterStyle}
              >{_allText}
              </span>
            </div>
          )
        } else if (orders.length > 0) {
          return (
            <div
              className={editTextStyle}
              onClick={() => switchClearAllOrdersMode(true)}
            >{_clearAllText}
            </div>
          )
        }
      }

      const renderLeftContent = () => {
        if (isCheckoutComplete) return
        return (
          <div>
            <img src={previousArrowImage} alt='back' />
          </div>
        )
      }

      const renderTitle = () => {
        const _chooseTableText = intl.formatMessage({ id: 'footer.choose_table' })
        if (isChangeTable || isChangeTableDetail) {
          return _chooseTableText
        }
      }

      const leftContent = renderLeftContent()
      const rightContent = renderRightContent()
      const title = renderTitle()

      return (
        <div>
          <NavBar
            className={navBarLiteStyle}
            mode='dark'
            onLeftClick={this.routeToPreviousHistory}
            leftContent={leftContent}
            rightContent={rightContent}
          >
            {title}
          </NavBar>
        </div>
      )
    }
}

export default injectSheet(styles)(NavBarLiteComponent)



// WEBPACK FOOTER //
// ./src/components/NavBarLite.js